import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectTasksFilters() {
  return (
    <div className="flex flex-wrap items-center gap-3 bg-white p-3 rounded-md border border-slate-100 ">
      {/* Ô tìm kiếm */}
      <div className="relative flex-1 min-w-[200px]">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
        <input
          type="text"
          placeholder="Tìm kiếm công việc..."
          className="w-full h-9 pl-9 pr-4 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
        />
      </div>

      {/* Bộ lọc Select */}
      <div className="flex flex-wrap items-center gap-2">
        <FilterSelect placeholder="Tất cả trạng thái" />
        <FilterSelect placeholder="Tất cả hạng mục" />
        <FilterSelect placeholder="Tất cả người phụ trách" />
        
        {/* Date Range Picker Placeholder */}
        <div className="flex items-center gap-2 h-9 px-3 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 cursor-pointer hover:bg-white transition-all font-normal">
          <span>Chọn khoảng thời gian</span>
          <i className="ri-calendar-line" />
        </div>

        {/* Nút lọc nâng cao */}
        <button className="h-9 px-4 rounded-md bg-emerald-600 text-white flex items-center gap-2 text-xs lg:text-sm font-normal hover:bg-emerald-700 transition-all  shadow-emerald-100">
          <i className="ri-filter-3-line" />
          <span>Bộ lọc</span>
        </button>

        {/* Chuyển đổi hiển thị */}
        <div className="flex items-center border border-slate-200 rounded-md overflow-hidden h-9">
          <button className="w-9 h-full flex items-center justify-center bg-emerald-50 text-emerald-600">
            <i className="ri-list-check" />
          </button>
          <button className="w-9 h-full flex items-center justify-center bg-white text-slate-400 hover:text-slate-600">
            <i className="ri-layout-grid-line" />
          </button>
        </div>
      </div>
    </div>
  );
}

function FilterSelect({ placeholder }: { placeholder: string }) {
  return (
    <div className="relative group min-w-[140px]">
      <select className="appearance-none w-full h-9 pl-3 pr-8 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all cursor-pointer">
        <option value="">{placeholder}</option>
      </select>
      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 group-hover:text-slate-600 pointer-events-none" />
    </div>
  );
}
